import { executeRequest } from "@/common/utils/http/httpClient";
import { getCurrentEnvironmentVariables } from "@/lib/CONSTANTS";
import { endpointMapper } from "@/common/service/endpoint.map.js";
import { replaceAllMatchPattern } from "@/common/utils/generic/commonHelper.js";

const envSpecificApiDomain = getCurrentEnvironmentVariables().apiDomain;

const subPath = "v1";
const subPathV2 = "v2";

const myPageApiPath = `${replaceAllMatchPattern(envSpecificApiDomain[subPath], endpointMapper[subPath].myPage)}`;
const myPageApiPathV2 = `${replaceAllMatchPattern(envSpecificApiDomain[subPathV2], endpointMapper[subPathV2].myPage)}`;
const inbondApiPath = `${replaceAllMatchPattern(envSpecificApiDomain[subPath], endpointMapper[subPath].inbond)}`;
const locationApiPath = `${replaceAllMatchPattern(envSpecificApiDomain[subPath], endpointMapper[subPath].location)}`;
const orchestrationApiPath = `${replaceAllMatchPattern(
  envSpecificApiDomain[subPath],
  endpointMapper[subPath].orchestration
)}`;
const inbondOrchestratorApiPath = `${replaceAllMatchPattern(
  envSpecificApiDomain[subPath],
  endpointMapper[subPath].inbondOrchestrator
)}`;
const dataAccumulationListenerApiPath = `${replaceAllMatchPattern(
  envSpecificApiDomain[subPath],
  endpointMapper[subPath].dataAccumulationListener
)}`;
const bolApiPath = `${replaceAllMatchPattern(envSpecificApiDomain[subPath], endpointMapper[subPath].billOfLading)}`;

// -----------------------------------------------------My Page Service (V2)-----------------------------------------------------
/**
 * getBolDetails
 * @description: Function which will trigger async call to get respective bol data
 *              based on the bol number to trigger this API
 * @returns Array of bol data object
 * @param: {*}
 */

const getBolDetails = async (bolNumber, consignmentType, rawResponse = false, masterNumber = "") => {
  let formattedConsignmentType = consignmentType == "LCL" ? "BOL" : consignmentType;
  let url = `${myPageApiPathV2}/aggregator/search/billOfLading?bolNumber=${bolNumber}&consignmentType=${formattedConsignmentType}`;

  if (masterNumber && consignmentType == "CONTAINER") {
    url = url + `&masterBolNumber=${masterNumber}`;
  }

  if (consignmentType && consignmentType == "LCL") {
    url = url + `&isLcl=true`;
  }
  return executeRequest({
    url,
    method: "GET",
    rawResponse
  });
};

const getComplianceDetails = async (bolNumber, complianceId, consignmenTypeOpted = "BOL", masterNumber = "") => {
  let url = `${myPageApiPathV2}/aggregator/search/compliance/bolref?bolNumber=${bolNumber}&complianceId=${complianceId}`;
  if (consignmenTypeOpted == "CONTAINER") {
    url = url + `&consignmentType=${consignmenTypeOpted}&masterNumber=${masterNumber}`;
  }
  return executeRequest({
    url,
    method: "GET"
  });
};

const getSubmissionDeadline = async cParams => {
  const { complianceID, complianceType, loadPortCode, vesselCode, voyageCode } = cParams;
  let url;
  if (complianceType == "Advance Manifest") {
    url = `${myPageApiPathV2}/aggregator/submissionDeadline?complianceId=${complianceID}&complianceType=${complianceType}&loadPort=${loadPortCode}&vesselCode=${vesselCode}&voyageCode=${voyageCode}`;
  } else {
    url = `${myPageApiPathV2}/aggregator/submissionDeadline?complianceId=${complianceID}&complianceType=${complianceType}`;
  }
  return executeRequest({
    url,
    method: "GET"
  });
};

const getHblDetails = async (bolNumber, rawResponse = false) => {
  const url = `${myPageApiPathV2}/aggregator/housebol/${bolNumber}`;
  return executeRequest({
    url,
    method: "GET",
    rawResponse
  });
};

/**
 * fetchExceptionData
 * @description: Function which will fetch the exception  data for the given set of the BOL
 * @returns Array of bol data object
 * @param: {*}
 */
const fetchExceptionData = async bolNumber => {
  const url = `${myPageApiPathV2}/aggregator/exceptions?bolIds=${bolNumber}`;
  return executeRequest({
    url,
    method: "GET"
  });
};

/**
 * getPartialBolDetails
 * @description: Function which will trigger async call to get respective bol data
 *              based on the bol number to trigger this API
 * @returns Array of bol data object
 * @param: {*}
 */

const getPartialBolDetails = async (bolNumber, consignmentType, rawResponse = false, masterNumber) => {
  let formattedConsignmentType = consignmentType == "LCL" ? "BOL" : consignmentType;
  let url = `${myPageApiPathV2}/aggregator/search/billOfLading?bolNumber=${bolNumber}&consignmentType=${formattedConsignmentType}&masterBolNumber=${masterNumber}`;

  return executeRequest({
    url,
    method: "GET",
    rawResponse
  });
};

/**
 * excludeFromCustomsSubmission
 * @description: Function which enable/disable the custom submission
 * @returns Array of bol data object
 * @param: {*}
 */

export async function excludeFromCustomsSubmission(req_body, rawResponse = false) {
  const url = `${myPageApiPathV2}/aggregator/update/excludeSubmission`;
  return executeRequest({
    url,
    method: "POST",
    body: JSON.stringify(req_body),
    rawResponse
  });
}

// -----------------------------------------------------My Page Service (V1)-----------------------------------------------------

// Pending
const saveCustomerSegment = async req_body => {
  const { body } = req_body;
  const url = `${orchestrationApiPath}/routeEnrichment/custom-segment`;

  return executeRequest({
    url,
    method: "PUT",
    body: JSON.stringify(body)
  });
};

const saveGODetails = async req_body => {
  const { params, body } = req_body;
  const url = `${myPageApiPath}/aggregator/updateGeneralOrder?bolNumber=${params.bolNumber}&complianceId=${params.complianceId}&userName=${params.userName}`;

  return executeRequest({
    url,
    method: "PUT",
    body: JSON.stringify(body)
  });
};

const getSNPDetails = async req_body => {
  const url = `${myPageApiPath}/aggregator/notify-party-details`;

  return executeRequest({
    url,
    method: "POST",
    body: JSON.stringify(req_body)
  });
};

const setHSCode = async (params, rawResponse = false) => {
  const { bolNumber, hscode, hsOldcode, cargoSequence, body } = params;
  const url = `${myPageApiPath}/aggregator/updateHS6CommodityDesc/?bolNumber=${bolNumber}&hs6CommodityCode=${hscode}&hs6CommodityCodeOld=${hsOldcode}&cargoSequence=${cargoSequence}`;
  return executeRequest({
    url,
    method: "PUT",
    body: JSON.stringify(body),
    rawResponse
  });
};

// -----------------------------------------------------Other Service (V1)-----------------------------------------------------

const pttService = async ({ data, type, rawResponse = false }) => {
  const { query, bolNumber, complianceId } = data;
  const apiList = {
    "ptt-display": {
      path: `/inbonds/find-ptt-history?bolNumber=${bolNumber}&complianceId=${complianceId}`,
      method: "GET",
      serviceUrl: inbondApiPath
    },
    "firms-code": {
      path: `/location/searchfirmscodes?query=${query}`,
      method: "GET",
      serviceUrl: locationApiPath
    },
    submit: {
      path: `/inbondOrchestrator/submit-ptt`,
      method: "PUT",
      serviceUrl: inbondOrchestratorApiPath
    }
  };
  const url = `${apiList[type].serviceUrl}${apiList[type].path}`;
  const requestOptions = {
    url,
    method: apiList[type].method,
    rawResponse
  };

  if (apiList[type].method === "PUT") {
    requestOptions.body = JSON.stringify(data);
  }

  return executeRequest(requestOptions);
};

const getLoadStatusDetails = async cParams => {
  const { bolNumber, vesselCode, departureVoyageNumber, fromSiteCode, toSiteCode } = cParams;

  const url = `${dataAccumulationListenerApiPath}/data-accumulation/aggregated-status?bolNumber=${bolNumber}&vesselCode=${vesselCode}&departureVoyageNumber=${departureVoyageNumber}&fromSiteCode=${fromSiteCode}&toSiteCode=${toSiteCode}`;
  return executeRequest({
    url,
    method: "GET"
  });
};

/**
 * multipleBills
 * @description: Function which will trigger async call to get multiple Booking details
 *              based on the bol number to trigger this API
 * @returns Array of bol data object
 * @param: {*}
 */
const multipleBills = async (bookingNumber, rawResponse = false) => {
  const url = `${bolApiPath}/billoflading/bookingNumbers/${bookingNumber}`;
  return executeRequest({
    url,
    method: "GET",
    rawResponse
  });
};

/**
 * fetchDeletedManifest
 * @description: Function which will trigger async call to get deleted manifest routing details
 *              based on the bol number
 * @returns Array of deleted manifest routing data
 * @param: {string} bolNumber - The BOL number to fetch deleted manifests for
 * @param: {boolean} rawResponse - Whether to return raw response
 */
const fetchDeletedManifest = async (bolNumber, rawResponse = false) => {
  const url = `${myPageApiPathV2}/aggregator/fetchDeletedmanifest?bolNumber=${bolNumber}`;
  return executeRequest({
    url,
    method: "GET",
    rawResponse
  });
};

export {
  getBolDetails,
  getComplianceDetails,
  saveCustomerSegment,
  saveGODetails,
  getSNPDetails,
  pttService,
  getLoadStatusDetails,
  getSubmissionDeadline,
  getHblDetails,
  setHSCode,
  fetchExceptionData,
  multipleBills,
  getPartialBolDetails,
  fetchDeletedManifest
};
